module.exports = __webpack_public_path__ + "static/media/icn_b_2.8f774fb1.svg";